import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirectionsRun = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.8333 19.1667V14.1667L9.08333 12.5L8.25 16.1667L2.5 15L2.83333 13.3333L6.83333 14.1667L8.16667 7.41667L6.66667 8V10.8333H5V6.91667L8.29167 5.5C8.77778 5.29167 9.13542 5.15625 9.36458 5.09375C9.59375 5.03125 9.80556 5 10 5C10.2917 5 10.5625 5.07639 10.8125 5.22917C11.0625 5.38194 11.2639 5.58333 11.4167 5.83333L12.25 7.16667C12.6111 7.75 13.1007 8.22917 13.7187 8.60417C14.3368 8.97917 15.0417 9.16667 15.8333 9.16667V10.8333C14.9167 10.8333 14.059 10.6424 13.2604 10.2604C12.4618 9.87847 11.7917 9.375 11.25 8.75L10.75 11.25L12.5 12.9167V19.1667H10.8333ZM11.25 4.58333C10.7917 4.58333 10.3993 4.42014 10.0729 4.09375C9.74653 3.76736 9.58333 3.375 9.58333 2.91667C9.58333 2.45833 9.74653 2.06597 10.0729 1.73958C10.3993 1.41319 10.7917 1.25 11.25 1.25C11.7083 1.25 12.1007 1.41319 12.4271 1.73958C12.7535 2.06597 12.9167 2.45833 12.9167 2.91667C12.9167 3.375 12.7535 3.76736 12.4271 4.09375C12.1007 4.42014 11.7083 4.58333 11.25 4.58333Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDirectionsRun);
export default ForwardRef;
